import React from 'react'
import Eta from '../../components/general/Eta'
import Banner from '../../components/general/Banner'
import { useTranslation } from 'react-i18next'
import img from '../../assets/images/img2.svg'

const ProductFamilyDetail = () => {
    const { t } = useTranslation()

    return (
        <Eta>
            <Banner title={t("control_system")} description={t("control_system_text")} />
            <div className='product-family-detail'>
                <div className='d-flex justify-content-center align-items-center'><img src={img} alt='' className='w-75 h-75' /></div>
                <div className='mt-3'>
                    <div><strong className='color1 f18 fw500'>{t("control_system")}</strong></div>
                    <div><span className='color1 f14 fw400'>{t("control_system_content")}</span></div>
                </div>
            </div>
        </Eta>
    )
}

export default ProductFamilyDetail
